import { loadView, loadWidget } from '@/utils/helpers';

const routes = [
  {
    path: '/',
    redirect: '/signin',
  },
  {
    path: '/signin',
    name: 'accounts.signin',
    component: loadView('greeters/Login'),
    meta: {
      pageTitle: 'Sign In',
      requiresAuth: false,
    },
  },
  {
    path: '/forgot-password',
    name: 'accounts.forgot-password',
    component: loadView('greeters/ForgotPassword'),
    meta: {
      pageTitle: 'Forgot Password',
      requiresAuth: false,
    },
  },
  {
    path: '/reset-password',
    name: 'accounts.reset-password',
    component: loadView('greeters/ResetPassword'),
    meta: {
      pageTitle: 'Reset Password',
      requiresAuth: false,
    },
  },
  {
    path: '/verification/:code',
    name: 'accounts.verification',
    component: loadView('greeters/AccountVerification'),
    meta: {
      pageTitle: 'Account Verification',
      requiresAuth: false,
    },
  },
  {
    path: '/actions/success',
    name: 'accounts.actions.success',
    component: loadWidget('pages/SuccessPage'),
    meta: {
      pageTitle: 'Success Page',
      requiresAuth: false,
    },
  },
  {
    path: '/home',
    name: 'home',
    component: loadView('Master'),
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: loadView('pages/dashboard/Index'),
        meta: {
          pageTitle: 'Home',
          requiresAuth: true,
        },
      },
      {
        path: '/products',
        name: 'products',
        component: loadView('pages/products/Index'),
        meta: {
          pageTitle: 'Products',
          requiresAuth: true,
        },
      },
      {
        path: '/products/add',
        name: 'products.add',
        component: loadView('pages/products/Create'),
        meta: {
          pageTitle: 'Add Product',
          requiresAuth: true,
        },
      },
      {
        path: '/products/:id/edit',
        name: 'products.edit',
        component: loadView('pages/products/Edit'),
        meta: {
          pageTitle: 'Edit Product',
          requiresAuth: true,
        },
      },
      {
        // Backed by messaging-ussd-mtn-aggregator (ussdThirdParty) — the registry
        // that actually routes live USSD traffic. The former sms-service-backed
        // page (pages/ussd-codes/Index) is no longer routed; see PR notes.
        path: '/ussd/service-codes',
        name: 'ussd.service.codes',
        component: loadView('pages/ussd/ServiceCodes'),
        meta: {
          pageTitle: 'USSD Service Codes',
          requiresAuth: true,
        },
      },
      {
        path: '/transactions',
        name: 'transactions',
        component: loadView('pages/transactions/Transactions'),
        meta: {
          pageTitle: 'Transactions',
          requiresAuth: true,
        },
      },
      {
        path: '/ussd/hits',
        name: 'ussd.hits',
        component: loadView('pages/ussd/HitReports'),
        meta: {
          pageTitle: 'USSD Hit Reports',
          requiresAuth: true,
        },
      },
      {
        path: '/analytics/ussd-hits',
        name: 'analytics.ussd-hits',
        component: loadView('pages/analytics/UssdHits'),
        meta: {
          pageTitle: 'USSD Hits',
          requiresAuth: true,
        },
      },
      {
        path: '/ussd/sessions',
        name: 'ussd.sessions',
        component: loadView('pages/ussd/Sessions'),
        meta: {
          pageTitle: 'Active USSD Sessions',
          requiresAuth: true,
        },
      },
      {
        path: '/payments',
        name: 'payments',
        component: loadView('pages/payments/AllPayments'),
        meta: {
          pageTitle: 'All Payments',
          requiresAuth: true,
        },
      },
      {
        path: '/analytics/daily-successful',
        name: 'analytics.daily-successful',
        component: loadView('pages/analytics/DailySuccessful'),
        meta: {
          pageTitle: 'Daily Successful Transactions',
          requiresAuth: true,
        },
      },
      {
        path: '/analytics/top-organizations',
        name: 'analytics.top-organizations',
        component: loadView('pages/analytics/TopOrganizations'),
        meta: {
          pageTitle: 'Top Organizations',
          requiresAuth: true,
        },
      },
      {
        path: '/analytics/overview',
        name: 'analytics.overview',
        component: loadView('pages/analytics/Overview'),
        meta: {
          pageTitle: 'Daily Transaction Overview',
          requiresAuth: true,
        },
      },
      {
        path: '/commissions',
        name: 'commissions',
        component: loadView('pages/commissions/AllCommissions'),
        meta: {
          pageTitle: 'All Commissions',
          requiresAuth: true,
        },
      },
      {
        path: '/payments/merchants',
        name: 'payments.merchants',
        component: loadView('pages/payments/MerchantCredentials'),
        meta: {
          pageTitle: 'Merchants',
          requiresAuth: true,
        },
      },
      {
        path: '/payments/callbacks',
        name: 'payments.callbacks',
        component: loadView('pages/payments/Callbacks'),
        meta: {
          pageTitle: 'Callbacks',
          requiresAuth: true,
        },
      },
      {
        path: '/merchants',
        name: 'merchants',
        component: loadView('pages/payments/Merchants'),
        meta: {
          pageTitle: 'All Merchants',
          requiresAuth: true,
        },
      },
      {
        path: '/payment-methods',
        name: 'payment-methods',
        component: loadView('pages/payments/PaymentMethod'),
        meta: {
          pageTitle: 'Payment Methods',
          requiresAuth: true,
        },
      },
      {
        path: '/disputes',
        name: 'disputes',
        component: loadView('pages/transactions/Transactions'),
        meta: {
          pageTitle: 'Transactions',
          requiresAuth: true,
        },
      },
      {
        path: '/archives',
        name: 'archives',
        component: loadView('pages/Archives'),
        meta: {
          pageTitle: 'Archives',
          requiresAuth: true,
        },
      },
      {
        path: '/trash',
        name: 'trash',
        component: loadView('pages/Trash'),
        meta: {
          pageTitle: 'Trash',
          requiresAuth: true,
        },
      },
      // SMS Routes
      {
        path: '/products/sms/dashboard',
        name: 'sms.dashboard',
        component: loadView('pages/products/sms/Dashboard'),
        meta: {
          pageTitle: 'SMS Dashboard',
          requiresAuth: true,
        },
      },
      {
        path: '/products/sms/customers',
        name: 'sms.customers',
        component: loadView('pages/products/sms/customers/Index'),
        meta: {
          pageTitle: 'All Customers',
          requiresAuth: true,
        },
      },
      {
        path: '/products/sms/customers/logs',
        name: 'sms.customers.logs',
        component: loadView('pages/products/sms/logs/Index'),
        meta: {
          pageTitle: 'Customer Logs',
          requiresAuth: true,
        },
      },
      {
        path: '/products/sms/sender-ids/all',
        name: 'sms.sender-id.all',
        component: loadView('pages/products/sms/sender-ids/AllSenderIDs'),
        meta: {
          pageTitle: 'All Sender IDs',
          requiresAuth: true,
        },
      },
      {
        path: '/products/sms/logs',
        name: 'sms.logs',
        component: loadView('pages/products/sms/logs/Index'),
        meta: {
          pageTitle: 'All Logs',
          requiresAuth: true,
        },
      },
      {
        path: '/products/sms/transactions',
        name: 'sms.transactions',
        component: loadView('pages/products/sms/transactions/Index'),
        meta: {
          pageTitle: 'SMS Transactions',
          requiresAuth: true,
        },
      },
      {
        path: '/products/cu/dashboard',
        name: 'cu.dashboard',
        component: loadView('pages/products/cu/Dashboard'),
        meta: {
          pageTitle: 'CU Dashboard',
          requiresAuth: true,
        },
      },
      {
        path: '/products/cu/customers',
        name: 'cu.customers',
        component: loadView('pages/products/cu/customers/Index'),
        meta: {
          pageTitle: 'All Credit Unions',
          requiresAuth: true,
        },
      },
      {
        path: '/products/cu/transactions',
        name: 'cu.transactions',
        component: loadView('pages/products/cu/Transactions'),
        meta: {
          pageTitle: 'All Transactions',
          requiresAuth: true,
        },
      },
      {
        path: '/products/cu/settlement-reports',
        name: 'cu.settlement-reports',
        component: loadView('pages/products/cu/SettlementReports'),
        meta: {
          pageTitle: 'Settlement Reports',
          requiresAuth: true,
        },
      },
      {
        path: '/products/cu/customers/add',
        name: 'cu.customers.add',
        component: loadView('pages/products/cu/customers/Create'),
        meta: {
          pageTitle: 'Create New Organization',
          requiresAuth: true,
        },
      },
      {
        path: '/products/cu/ussd/access/counts',
        name: 'cu.ussd.access-counts',
        component: loadView('pages/products/cu/AccessCounts'),
        meta: {
          pageTitle: 'USSD Access Count',
          requiresAuth: true,
        },
      },
      {
        path: '/products/cu/autocredit-pending-review',
        name: 'cu.autocredit-pending-review',
        component: loadView('pages/products/cu/AutocreditPendingReview'),
        meta: {
          pageTitle: 'Autocredit Pending Review',
          requiresAuth: true,
        },
      },
      {
        path: '/products/cu/autocredit-processed',
        name: 'cu.autocredit-processed',
        component: loadView('pages/products/cu/AutocreditProcessed'),
        meta: {
          pageTitle: 'Processed Autocredits',
          requiresAuth: true,
        },
      },
      {
        path: '/products/cu/autocredit-bank-details',
        name: 'cu.autocredit-bank-details',
        component: loadView('pages/products/cu/AutocreditBankDetails'),
        meta: {
          pageTitle: 'Autocredit Bank Details',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '*',
    redirect: '/404',
  },
  {
    path: '/404',
    name: '404',
    component: loadWidget('pages/Error404'),
  },
];

export default routes;
